<template>
  <button
    class="enroll-btn"
    :type="type"
    :class="btnClass"
    @click="handleClick"
  >
    <!-- <i :class="icon" v-if="icon"></i> -->
    <slot></slot>
  </button>
</template>

<script>
const COMPONENT_NAME = 'enroll-button';
export default {
  name: COMPONENT_NAME,
  props: {
    type: {
      type: String,
      default: 'button',
    },
    active: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    btnClass() {
      return {
        'enroll-btn_active': this.active,
        'enroll-btn_disabled': this.disabled,
      };
    },
  },

  methods: {
    handleClick(event) {
      if (this.disabled) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      this.$emit('click', event);
    },
  },
};
</script>

<style lang="scss" scoped>
.enroll-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 98px;
  color: #fff;
  font-size: 30px;
  border: none;
  border-radius: 49px;
  &:active {
    opacity: 0.8;
  }
  &.enroll-btn_active {
    background-color: #6749ec;
  }

  &.enroll-btn_disabled {
    background-color: #dbdada;
  }
}
</style>
